










































































import Vue from 'vue';
import Component from 'vue-class-component';
import { DataCenters } from '@/modules/shared/shared/domain/constants/constants';
import VueApexCharts from 'vue-apexcharts/dist/vue-apexcharts';

@Component({
    components: {
        apexchart: VueApexCharts,
    },
    name: 'environmental-control-system-availability',
})
export default class EnvironmentalControlSystemAvailability extends Vue {
    dataCentersArray: { id: number; name: string; location: string }[] = [
        DataCenters.DATA_CENTER_CARACAS,
        DataCenters.DATA_CENTER_VALENCIA,
    ];
    caracasChartColor: string = '#00AAB8';
    valenciaChartColor: string = '#60BB46';

    getChartColor(id: number): string {
        if (id === DataCenters.DATA_CENTER_CARACAS.id) {
            return this.caracasChartColor;
        }

        return this.valenciaChartColor;
    }

    chartOptions(id: number) {
        return {
            chart: {
                type: 'radialBar',
                offsetY: -20,
                sparkline: {
                    enabled: true,
                },
            },
            plotOptions: {
                radialBar: {
                    startAngle: -90,
                    endAngle: 90,
                    track: {
                        background: '#e7e7e7',
                        strokeWidth: '97%',
                        margin: 5,
                        dropShadow: {
                            enabled: true,
                            top: 2,
                            left: 0,
                            color: '#999',
                            opacity: 1,
                            blur: 2,
                        },
                    },
                    dataLabels: {
                        name: {
                            show: false,
                        },
                        value: {
                            offsetY: -2,
                            fontSize: '15px',
                        },
                    },
                },
            },
            grid: {
                padding: {
                    top: -10,
                },
            },
            colors: [this.getChartColor(id)],
            fill: {
                type: 'gradient',
                gradient: {
                    shade: 'light',
                    shadeIntensity: 0.4,
                    inverseColors: false,
                    opacityFrom: 1,
                    opacityTo: 1,
                    stops: [0, 50, 53, 91],
                },
            },
        };
    }
}
